/*
 * @Author: Xu Chen
 * @Date: 2019-05-09 15:37:24
 * @Last Modified by: gujt
 * @Last Modified time: 2020-03-26 09:08:03
 * @description: 教师查看考勤看板
 */

import request from '@/plugin/axios';

export default {
  /* 根据学校ID及用户ID获取班级列表 */
  getClassListByUserIdAndSchoolId(payload) {
    const params = {
      ...payload,
      requestFlag: '1'
    };

    return request({
      url: '/baseApi/class/getClassListByUserIdAndSchoolId',
      method: 'post',
      data: params
    });
  },
  /* 根据学校ID获取班级列表 */
  getClassListBySchoolId(payload) {
    const params = {
      ...payload
      // requestFlag: '1'
    };

    return request({
      url: '/baseApi/class/getClassListByUserIdAndSchoolId',
      method: 'post',
      data: params
    });
  },

  /* 根据班级ID获取作息时间列表 */
  getSchedulesByClassId(payload) {
    const params = {
      ...payload
    };

    return request({
      url: '/baseApi/schedules/getSchedulesByClassId',
      method: 'post',
      data: params
    });
  },

  /* 获取考勤结果 */
  getAttendanceResult(payload) {
    const params = {
      ...payload
    };

    return request({
      url: '/attendanceApi/teacherStatistics/getAttendanceResult',
      method: 'post',
      data: params
    });
  },

  /* 获取学校列表 */
  getSchoolList(payload) {
    const params = {
      ...payload,
      requestFlag: '1'
    };

    return request({
      url: '/baseApi/school/getSchoolListByUser',
      method: 'post',
      data: params
    });
  }
};

/* begin 新接口 融合教师特征值管理*/

/* 注册人脸特征值 */
export function registFeature(payload) {
  const params = {
    ...payload
  };

  return request({
    // url: '/teacherBaseApi/transfer/addIntegrateLicense',
    url: '/baseApi/teacher/uploadTeacherFeature',
    method: 'post',
    data: params,
    headers: {
      dispatch: 'AIGenerateFaceFeature',
      accept: 'application/json'
    }
  });
}

export function teacherCountStatistic(schoolId) {
  const params = {
    schoolId
  };
  return request({
    // url: '/teacherBaseApi/user/getTeacherInfoBySchool',
    url: '/baseApi/teacher/getTeacherInfoBySchool',
    method: 'post',
    data: params
  });
}

// 开通学校
export function teacherGrantSchool(schoolForm, schoolInfo) {
  const params = {
    third_party_id: schoolInfo[0],
    name: schoolInfo[1],
    code: schoolInfo[2],
    studentCount: 99999,
    iotUUid: schoolForm.plant,
    data_source: 'hitecloud',
    application: 'PCClient',
    license: '1'
  };
  return request({
    url: '/teacherBaseApi/school/grantSchool',
    method: 'post',
    data: params
  });
}
/* end 新接口 融合教师特征值管理*/
